module.exports = __webpack_public_path__ + "img/18_97.cb1327d7.png";